import React from 'react'

const PNF = () => {
  return (
    <div>
      <h1>PAGE NOT FOUND 404</h1>
    </div>
  )
}

export default PNF
